module.exports = __webpack_public_path__ + "img/innovation3.640db37f.svg";